import {loadLookupRecord} from '../../../../utils/effectivePermissions';
import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Calendar} from "primereact/calendar";
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputMask} from "primereact/inputmask";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import {AutoComplete} from "primereact/autocomplete";
import {Checkbox} from "primereact/checkbox";
import axios from "axios";
import moment from "moment/moment";
import { InputNumber } from 'primereact/inputnumber';

const FulfilmentFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {action, entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [types, setTypes] = useState([]);
  const [partners, setPartners] = useState([]);
  const [partnerQuery, setPartnerQuery] = useState('');
  const [partnerLoading, setPartnerLoading] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [contractQuery, setContractQuery] = useState('');
  const [contractLoading, setContractLoading] = useState(false);
  const urlVars = window.App.urlVars();

  const getNumericId = (value) => {
    const decoded = decodeURIComponent(String(value || ''));
    const match = decoded.match(/(\d+)$/);
    return match ? Number(match[1]) : null;
  };

  const fixedProjectId = getNumericId(urlVars.projectId || id);
  const fixedType = urlVars.type || '';
  const fixedName = decodeURIComponent(String(urlVars.name || '').replace(/\+/g, ' '));
  // const fixedPartnerId = urlVars.partnerId ? Number(urlVars.partnerId) : null;
  const selectedPartnerFromBrowse = !!urlVars.partnerId && !!urlVars.partnerName;

  const fixedPartnerId = urlVars.partnerId && !selectedPartnerFromBrowse ? Number(urlVars.partnerId) : null;
  const fixedContractId = urlVars.contractId ? Number(urlVars.contractId) : null;
  const fixedCurrency = urlVars.currency || null;

  const hasFixedType = !!fixedType;
  const hasFixedPartner = !!fixedPartnerId;
  const hasFixedContract = !!fixedContractId;
  const [formData, setFormData] = useState({
    issue_date: new Date(),
    date: new Date(),
    project: fixedProjectId,
    name: fixedName,
    type: fixedType,
    partner: fixedPartnerId,
    contract: fixedContractId,
    currency: fixedCurrency
  });

  const decodeUrlValue = (value) => {
    return decodeURIComponent(String(value || '').replace(/\+/g, ' '));
  };

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
      setLoading(true)
      const submissionData = {
    ...data,

    project:
      fixedProjectId ||
      (formData.project && typeof formData.project === 'object' ? formData.project.id : Number(formData.project)) ||
      (data.project && typeof data.project === 'object' ? data.project.id : Number(data.project)) ||
      null,

    type:
      fixedType ||
      formData.type ||
      data.type ||
      null,

    partner:
      fixedPartnerId ||
      (formData.partner && typeof formData.partner === 'object' ? formData.partner.id : formData.partner) ||
      (data.partner && typeof data.partner === 'object' ? data.partner.id : data.partner) ||
      null,

    contract:
      fixedContractId ||
      (formData.contract && typeof formData.contract === 'object' ? formData.contract.id : formData.contract) ||
      (data.contract && typeof data.contract === 'object' ? data.contract.id : data.contract) ||
      null
    };
    if ((id && entity === 'fulfilment') || (window.App.urlVars().update === 'fulfilment' && window.App.urlVars().fulfilmentId)) {
      const payload = {
        ...submissionData,
        issue_date: moment(formData.date || formData.issue_date).format('YYYY-MM-DD')
      }
      axios.patch(process.env.REACT_APP_API_HOST + "/api/v2/fulfillment/" + (window.App.urlVars().fulfilmentId ?? id),
        payload,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderFulfilmentList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/project/fulfilment/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      const payload = {
        ...submissionData,
        issue_date: moment(formData.date).format('YYYY-MM-DD')
      }
      axios.post(process.env.REACT_APP_API_HOST + "/api/v2/fulfillment",
        payload,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderFulfilmentList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/project/fulfilment/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const searchContract = (event) => {
    const q = (event?.query || '').trim();
    setContractQuery(q);
    if (q.length < 2) {
      setContracts([]);
      return;
    }
    setContractLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/contract", {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      },
      params: {
        rows: 15,
        'search[name][operator]': 'like',
        'search[name][value]': `%${q}%`,
        ...(formData.partner ? {
          'search[partner][operator]': '=',
          'search[partner][value]': typeof formData.partner === 'object' ? formData.partner.id : formData.partner
        } : {})
      },
    })
      .then(response => {
        const items = response?.data?.data?.items || [];
        const mapped = items.map((contract) => ({
          ...contract,
          displayName:
            contract.name +
            (
              contract.address_postal_code ||
              contract.address_city ||
              contract.address_detail
                ? ` (${contract.address_postal_code || ''} ${contract.address_city || ''}, ${contract.address_detail || ''})`
                : ''
            )
        }));
        setContracts(mapped);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setContractLoading(false);
      });
  };

  const searchPartner = (event) => {
    const q = (event?.query || '').trim();
    setPartnerQuery(q);
    if (q.length < 2) {
      setPartners([]);
      return;
    }
    setPartnerLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/partner", {
      params: {
        rows: 15,
        'search[name][operator]': 'like',
        'search[name][value]': `%${q}%`
      },
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        const items = response?.data?.data?.items || [];
        const mapped = items.map((partner) => ({
          ...partner,
          displayName:
            partner.name +
            (
              partner.address_postal_code ||
              partner.address_city ||
              partner.address_detail
                ? ` (${partner.address_postal_code || ''} ${partner.address_city || ''}, ${partner.address_detail || ''})`
                : ''
            )
        }));
        setPartners(mapped);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setPartnerLoading(false);
      });
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  useEffect(() => {
    setLoading(true);
    const projectId = getNumericId(window.App.urlVars().projectId || id);
    const fulfillmentId = window.App.urlVars().fulfilmentId || (entity === 'fulfilment' ? id : null);
    if ((id && entity === 'action') || (window.App.urlVars().update === 'action' && window.App.urlVars().actionId)) {
      axios.get(process.env.REACT_APP_API_HOST + "/api/v2/crm-action/" + (window.App.urlVars().actionId ?? id),
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
    if (fulfillmentId && (action === 'update' || entity === 'fulfilment'|| window.App.urlVars().update === 'fulfilment')) {
        axios.get(process.env.REACT_APP_API_HOST + "/api/v2/fulfillment/" + fulfillmentId, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                'App-Network': localStorage.getItem("networkId")
            }
        })
        .then(response => {
          const data = response.data.data;
          const contractDisplayName = data.contract ? (
              data.contract.name ||
              data.contract.contract_number ||
              `Szerződés #${data.contract.id}`
            )
            : '';
          setFormData({
            ...data,
            partner: data.partner?.id || data.partner || null,
            contract: data.contract?.id || data.contract || null,
            date: data.issue_date ? new Date(data.issue_date) : new Date()
          });
          setPartnerQuery(data.partner?.name || '');
          setContractQuery(contractDisplayName);
        })
        .catch(error => {
            window.App.toastShow('error', t('error'), error.toString());
        })
        .finally(() => setLoading(false));
    }
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/dictionary/currency",
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }      
      })
      .then(response => {
        setCurrencies(response.data.data || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/dictionary/contract-role",
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setTypes(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/contract",
      {
        params: { },
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        const items = response?.data?.data?.items || [];
        const mapped = items.map((contract) => ({
          ...contract,
          displayName: contract.name || contract.contract_number || `Szerződés #${contract.id}`
        }));
        setContracts(mapped);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
    if (projectId && !fulfillmentId) {
      loadLookupRecord((method, path) => axios.get(process.env.REACT_APP_API_HOST + path, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      }), 'project', projectId, 'ROLE_PROJECT_READ').then(response => {
        const projectData = response.data.data;
        if (!projectData) return;
        setFormData(prev => {
          const isMainContractor = prev.type === 'MAIN_CONTRACTOR';
          const nextPartner =
            isMainContractor && projectData.partner && typeof projectData.partner === 'object'
              ? projectData.partner.id
              : prev.partner || null;

          if (isMainContractor) {
            setPartnerQuery(projectData.partner?.name || '');
          }
          return {
            ...prev,
            name: prev.name || fixedName || projectData.name,
            partner: nextPartner,
            currency: prev.currency || projectData.currency
          };
        });
      }).finally(() => setLoading(false));
    }
  }, [id, entity, action])

  useEffect(() => {
    const partnerId = window.App.urlVars().partnerId;
    const partnerName = window.App.urlVars().partnerName;
    if (partnerId && partnerName) {
      setFormData(prev => ({
        ...prev,
        partner: Number(partnerId)
      }));
      setPartnerQuery(decodeUrlValue(partnerName));
    }
  }, [window.location.hash]);

  useEffect(() => {
    const contractId = window.App.urlVars().contractId;
    const contractName = window.App.urlVars().contractName;
    const contractPartnerId = window.App.urlVars().contractPartnerId;
    const contractPartnerName = window.App.urlVars().contractPartnerName;
    if (contractId && contractName) {
      setFormData(prev => {
        const next = {
          ...prev,
          contract: Number(contractId)
        };
        if (!next.partner && contractPartnerId) {
          next.partner = Number(contractPartnerId);
        }
        return next;
      });
      setContractQuery(decodeURIComponent(contractName));
      if (!formData.partner && contractPartnerName) {
        setPartnerQuery(decodeURIComponent(contractPartnerName));
      }
    }
  }, [window.location.hash]);

  return (
    <div className={"action-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData} key={formData.id || 'new'}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="serial" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="serial"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldSerialNumber')}</label>
                  <span className="p-d-block">
                      <InputNumber id="serial" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     serial: e.value
                                   })
                                 }}
                                 value={formData.serial}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="date" render={({input, meta}) => (
                <span className="p-field p-fluid">
                    <label htmlFor="date"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldFulfillmentDay')}</label>
                    <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"date"}
                                       mask={"9999-99-99"}
                                       placeholder={t('datePlaceholder')}
                                       value={formData?.date ? moment.utc(formData.date).local().format('YYYY-MM-DD') : ''}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           setFormData({
                                             ...formData,
                                             date: new Date(e.value)
                                           })
                                         }
                                       }}
                            />
                            <Calendar value={formData.date}
                                      locale="hu"
                                      dateFormat={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          date: e.value
                                        })
                                      }}/>
                    </div>
                  {getFormErrorMessage(meta)}
                  </span>
              )}/>
            </div>
            {!hasFixedType &&
            <div className={"p-col-12 p-lg-4"}>
              <Field name="type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="type"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldFulfillmentType')}</label>
                  <span className={"p-d-block"}>
                      <Dropdown {...input}
                                value={input.value}
                                disabled={!!formData.id || !!window.App.urlVars().type || window.App.urlVars().update === 'fulfilment'}
                                onChange={(e) => {
                                  input.onChange(e.value)
                                  setFormData({
                                    ...formData,
                                    type: e.value
                                  })
                                }}
                                options={window.App.sortDropdownOptions(types, "value")}
                                optionLabel="value"
                                optionValue="key"
                                id={"type"}
                                emptyMessage={t('selectTypeFormalPlaceholder')}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            }
            {!hasFixedPartner &&
            <div className={"p-col-12 p-lg-6"}>
              <Field
                name="partner"
                render={({ input, meta }) => (
                  <div className="p-field p-fluid">
                    <label
                      htmlFor="partner"
                      className={classNames({ 'p-error': isFormFieldValid(meta) })}
                    >{props.t('fieldPartner')}</label>

                    <span className={"p-field p-inputgroup"}>
                      <Button
                        type="button"
                        className={"p-button"}
                        onClick={() => {
                          const current = window.location.hash.replace('#', '');
                          const currentPath = current.split('?')[0];
                          const currentSearch = current.split('?')[1] || '';
                          const params = new URLSearchParams(currentSearch);
                          params.set('backlink', current);
                          params.set('search', 'partner');
                          history.push(currentPath + '?' + params.toString());
                        }}
                      >
                        <i className={"pi pi-search"}></i>
                      </Button>

                      <AutoComplete
                        id="partner"
                        loading={partnerLoading}
                        value={partnerQuery}
                        suggestions={partners}
                        completeMethod={searchPartner}
                        field="displayName"
                        forceSelection
                        delay={700}
                        placeholder={t('typeToSearchPlaceholder')}
                        className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                        onSelect={(e) => {
                          const p = e.value;
                          if (!p?.id) return;

                          input.onChange(Number(p.id));
                          setPartnerQuery(p.displayName || p.name || '');

                          setFormData(prev => ({
                            ...prev,
                            partner: Number(p.id)
                          }));
                        }}
                        onChange={(e) => {
                          setPartnerQuery(e.value);

                          if (!e.value || String(e.value).trim() === '') {
                            input.onChange(null);
                            setFormData(prev => ({
                              ...prev,
                              partner: null
                            }));
                          }
                        }}
                        onClear={() => {
                          setPartnerQuery('');
                          input.onChange(null);
                          setFormData(prev => ({
                            ...prev,
                            partner: null
                          }));
                        }}
                      />

                      <Button
                        type="button"
                        className={"p-button"}
                        onClick={() => {
                          const currentPath = window.location.hash.replace('#', '').split('?')[0];
                          const currentVars = window.App.urlVars();
                          const nextParams = new URLSearchParams();

                          Object.entries(currentVars).forEach(([key, value]) => {
                            if (key !== 'formData' && key !== 'createPartner') {
                              nextParams.append(key, value);
                            }
                          });

                          nextParams.append('formData', JSON.stringify(formData));
                          nextParams.append('backlink', window.location.hash.replace('#', ''));
                          nextParams.append('createPartner', 'true');

                          history.push(currentPath + '?' + nextParams.toString());
                        }}
                      >
                        <i className={"pi pi-plus"}></i>
                      </Button>
                    </span>

                    {getFormErrorMessage(meta)}
                  </div>
                )}
              />
            </div>
            }
            <div className={"p-col-12 p-xl-4"}>
              <Field name="currency" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="currency"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCurrency')}</label>
                  <span className="p-d-block">
                    <Dropdown options={window.App.sortDropdownOptions(currencies, "key")}
                              optionLabel="key"
                              optionValue="key"
                              id={"currency"}
                              emptyMessage={t('noCurrencyYet')}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  currency: e.value
                                })
                              }}
                              value={formData.currency}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {formData.type === 'SUBCONTRACTOR' && !hasFixedContract &&
              <div className={"p-col-12 p-lg-6"}>
                <Field
                  name="contract"
                  render={({ input, meta }) => (
                    <div className="p-field p-fluid">
                      <label
                        htmlFor="contract"
                        className={classNames({ 'p-error': isFormFieldValid(meta) })}
                      >{props.t('contract')}</label>

                      <span className={"p-field p-inputgroup"}>
                        <Button
                          type="button"
                          className={"p-button"}
                          onClick={() => {
                            const current = window.location.hash.replace('#', '');
                            const currentPath = current.split('?')[0];
                            const currentSearch = current.split('?')[1] || '';
                            const params = new URLSearchParams(currentSearch);
                            params.set('backlink', current);
                            params.set('search', 'contract');

                            if (formData.partner) {
                              const partnerId = typeof formData.partner === 'object' ? formData.partner.id : formData.partner;
                              params.set('contractPartnerId', partnerId);
                            }
                            history.push(currentPath + '?' + params.toString());
                          }}
                        >
                          <i className={"pi pi-search"}></i>
                        </Button>

                        <AutoComplete
                          id="contract"
                          loading={contractLoading}
                          value={contractQuery}
                          suggestions={contracts}
                          completeMethod={searchContract}
                          field="displayName"
                          forceSelection
                          delay={700}
                          placeholder={t('typeToSearchPlaceholder')}
                          className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                          onSelect={(e) => {
                            const p = e.value;
                            if (!p?.id) return;

                            input.onChange(Number(p.id));
                            setContractQuery(p.displayName || p.name || '');

                            setFormData(prev => ({
                              ...prev,
                              contract: Number(p.id)
                            }));
                          }}
                          onChange={(e) => {
                            setContractQuery(e.value);

                            if (!e.value || String(e.value).trim() === '') {
                              input.onChange(null);
                              setFormData(prev => ({
                                ...prev,
                                contract: null
                              }));
                            }
                          }}
                          onClear={() => {
                            setContractQuery('');
                            input.onChange(null);
                            setFormData(prev => ({
                              ...prev,
                              contract: null
                            }));
                          }}
                        />

                        <Button
                          type="button"
                          className={"p-button"}
                          onClick={() => {
                            const currentPath = window.location.hash.replace('#', '').split('?')[0];
                            const currentVars = window.App.urlVars();
                            const nextParams = new URLSearchParams();

                            Object.entries(currentVars).forEach(([key, value]) => {
                              if (key !== 'formData' && key !== 'createContract') {
                                nextParams.append(key, value);
                              }
                            });

                            nextParams.append('formData', JSON.stringify(formData));
                            nextParams.append('backlink', window.location.hash.replace('#', ''));
                            nextParams.append('createContract', 'true');

                            history.push(currentPath + '?' + nextParams.toString());
                          }}
                        >
                          <i className={"pi pi-plus"}></i>
                        </Button>
                      </span>

                      {getFormErrorMessage(meta)}
                    </div>
                  )}
                />
              </div>
            }
            <div className={"p-col-12 p-xl-4"}>
              <Field name="currency" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="currency"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldFinal')}</label>
                  <span className="p-d-block">
                    <Checkbox
                      inputId="final"
                      checked={formData.final || false}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          final: e.checked
                        })
                      }}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'action' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(FulfilmentFormComponent);
